module.exports = __webpack_public_path__ + "img/icon_heart_2.7d3e0c6c.svg";